import { Component, Input } from '@angular/core';
import { DisplayOptions, Filter } from '../../models/filter-models';
import { DisplayType } from "../../models/enums";
import { EquipmentType } from "../../models/equipment-type.enum";
import { Rarity } from "../../models/enums";
import { FormsModule } from '@angular/forms';
import { AutocompleteComponent } from '../../common/autocomplete/autocomplete.component';
import { FilterTitleComponent } from '../../common/filter-title/filter-title.component';
import { FilterService } from '../../services/filter.service';
import { BaseType } from '../../models/item-data-models';
import { ItemDataService } from '../../services/item-data.service';
import { BaseComponent } from '../../common/base.component';
import { CosmeticControls } from '../../cosmetic-tab/cosmetic-controls.model';
import { GearTierIconComponent } from "../../common/icons/gear-tier-icon/gear-tier-icon.component";
import { SelectGearTierComponent } from '../../common/select/select-gear-tier/select-gear-tier.component';
import { ActiveRules, ActiveSpecialRules } from '../../services/filter-generator.service';
import { BaseTypeTier } from '../../models/enums';
import { poe1 } from '../../../game';
import { EquipmentTierPickerComponent } from "../../common/equipment-tier-picker/equipment-tier-picker.component";
import { FilterCheckboxGroupComponent } from '../../common/filter-checkbox-group/filter-checkbox-group.component';
import { JewelleryTierService } from '../../services/tiering/jewellery-tier.service';

@Component({
  selector: 'app-crafting-base-filters-poe2',
  imports: [FormsModule, AutocompleteComponent, FilterTitleComponent, GearTierIconComponent, SelectGearTierComponent, EquipmentTierPickerComponent, FilterCheckboxGroupComponent],
  templateUrl: './crafting-base-filters-poe2.component.html',
  styleUrl: './crafting-base-filters-poe2.component.scss'
})
export class CraftingBaseFiltersPoe2Component extends BaseComponent {
  @Input({ required: true }) filter!: Filter;
  @Input({ required: true }) activeRules!: ActiveRules;
  @Input({ required: true }) activeSpecialRules!: ActiveSpecialRules;

  charmBaseTypes: BaseType[] = [];
  excellentJewelleryBaseTypes: string[] = [];
  goodJewelleryBaseTypes: string[] = [];

  showExceptionalQualityGearFilters = false;
  showExceptionalSocketedGearFilters = false;

  craftingBaseLabelStyleOverridesControls = new CosmeticControls();

  Rarity = Rarity;
  DisplayType = DisplayType;
  BaseTypeTier = BaseTypeTier;
  EquipmentType = EquipmentType;

  constructor(
    private filterService: FilterService,
    private itemDataService: ItemDataService,
    jewelleryTierService: JewelleryTierService,
  ) {
    super();

    this.charmBaseTypes = poe1 ? [] : this.itemDataService.getItemData().find(i => i.itemType === 'Charms')!.baseTypes;

    const rareOnly = new Set(this.itemDataService.getRareOnlyJewellery());
    const jewelleryTierData = jewelleryTierService.getJewelleryTierData();
    this.excellentJewelleryBaseTypes = jewelleryTierData.filter(j => j.tier === 'Excellent' && !rareOnly.has(j.name)).map(j => j.name);
    this.goodJewelleryBaseTypes = jewelleryTierData.filter(j => j.tier === 'Good' && !rareOnly.has(j.name)).map(j => j.name);
  }

  toggleHighlight(displayOptions: DisplayOptions) {
    displayOptions.active = !displayOptions.active;
  }

  toggleHighlightExcellentExceptionalQualityGear = () => {
    this.filter.showExcellentExceptionalQualityGear = !this.filter.showExcellentExceptionalQualityGear;
    if (!this.filter.showExcellentExceptionalQualityGear) {
      this.filter.showGoodExceptionalQualityGear = false;
      this.showExceptionalQualityGearFilters = false;
    }
    this.updateFilter();
  }

  toggleHighlightExcellentExceptionalSocketedGear = () => {
    this.filter.showExcellentExceptionalSocketedGear = !this.filter.showExcellentExceptionalSocketedGear;
    if (!this.filter.showExcellentExceptionalSocketedGear) {
      this.filter.showGoodExceptionalSocketedGear = false;
      this.showExceptionalSocketedGearFilters = false;
    }
    this.updateFilter();
  }

  toggleHighlightILevel82NormalGear = () => {
    this.filter.showILevel82NormalGear = !this.filter.showILevel82NormalGear;
    if (!this.filter.showILevel82NormalGear) {
      this.filter.showILevel81NormalGear = false;
    }
    this.updateFilter();
  }

  toggleHighlightExcellentJewelleryBaseTypes = () => {
    this.filter.showExcellentJewelleryBaseTypes = !this.filter.showExcellentJewelleryBaseTypes;
    if (!this.filter.showExcellentJewelleryBaseTypes) {
      this.filter.showGoodJewelleryBaseTypes = false;
    }
    this.updateFilter();
  }

  toggleHighlightHighILevelCharms = () => { this.filter.showHighILevelCharms = !this.filter.showHighILevelCharms; this.updateFilter(); }

  updateFilter() {
    this.filterService.updateFilter();
  }
}
